var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonPrintOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.1779H14.3438C14.7164 13.1768 15.0734 13.0283 15.3369 12.7648C15.6004 12.5013 15.7489 12.1443 15.75 11.7717V6.14667C15.7489 5.77405 15.6004 5.41701 15.3369 5.15353C15.0734 4.89005 14.7164 4.74153 14.3438 4.74042H3.65625C3.28363 4.74153 2.92659 4.89005 2.66311 5.15353C2.39963 5.41701 2.25111 5.77405 2.25 6.14667V11.7717C2.25111 12.1443 2.39963 12.5013 2.66311 12.7648C2.92659 13.0283 3.28363 13.1768 3.65625 13.1779H4.5",
    stroke: "#00C455",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.645 8.67792H5.355C4.8828 8.67792 4.5 9.06071 4.5 9.53292V15.1354C4.5 15.6076 4.8828 15.9904 5.355 15.9904H12.645C13.1172 15.9904 13.5 15.6076 13.5 15.1354V9.53292C13.5 9.06071 13.1172 8.67792 12.645 8.67792Z",
    stroke: "#00C455",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.74042V3.71635C13.4989 3.26411 13.3504 2.83077 13.0869 2.51098C12.8234 2.19119 12.4664 2.01093 12.0938 2.00958H5.90625C5.53363 2.01093 5.17659 2.19119 4.91311 2.51098C4.64963 2.83077 4.50111 3.26411 4.5 3.71635V4.74042",
    stroke: "#00C455",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonPrintOutline);
export default __webpack_public_path__ + "static/media/ion_print-outline.790b898381a58513ecfef64f2807578b.svg";
export { ForwardRef as ReactComponent };